<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-3 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>


            <div class="row" style="margin-top: 15px" v-if="model.id">
              <div class="col-lg-4 col-md-6">
                <p style="margin: 0; min-width: 110px;">{{$t('settingTable.loginCode')}}</p>
              </div>
              <div class="col-lg-8 col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(model.id + '.' + company_id)" disabled=true :value="model.id + '.' + company_id">
                  </div>
                  <div class="col-md-2">
                    <a
                      class="btn btn-icon btn-info mar-rt-10"
                      :title="$t('general.copyToClipboard')"
                      style="padding: 6px 5px;"
                      @click="copyToClipboard(model.id + '.' + company_id)">
                      <i class="fa fa-copy"></i>
                    </a>
                  </div>

                </div>
              </div>
            </div>

            <!-- <template v-if="model.login_token">
              <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="deleteToken" style="width: auto; padding: 7px 10px; margin-right: 20px;">
                <img src="/static/img/icons/icon-close.png">
                {{$t('settingTable.disableAuthScreen')}}
              </a>
              <br>
            </template> -->
            <br>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Name</label>
                  <input id="name" class="form-control" type="text" v-model="model.name">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.location')}}</label>
                  <select
                    name="location"
                    class="form-control"
                    v-model="model.location.id"
                    @change="updateLocationId($event)"
                  >
                    <option value="null">{{$t('general.all')}}</option>
                    <option
                      v-for="(loc) in locations"
                      :value="loc.id"
                      :label="loc.name"
                      :key="loc.id">
                    </option>
                  </select>
                  <small class="text-danger" v-show="type.invalid">
                    {{ getError('type') }}
                  </small>
                </div>

                <div class="form-group">
                  <label for="name">Server Local Ip</label>
                  <input id="name" class="form-control" type="text" placeholder="192.168.1.10"
                  v-validate="modelValidate.server_ip"
                  v-model="model.server_ip">
                </div>

                <div class="form-group">
                  <label>Pos</label>
                  <select
                    name="type"
                    class="form-control"
                    v-model="model.pos_id"
                  >
                    <option :value="null" :label="$t('general.select')"> </option>
                    <option
                      v-for="pos in allPoses"
                      :value="pos.id"
                      :label="pos.name"
                      :key="pos.id">
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{$t('catalogProd.image')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="2"
                      :file-list="model.pos_image"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="handleImgChnagePosImage"
                      :on-exceed="handleExceed"
                      :on-remove="handleRemovePosImage"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                    </el-upload>
                </div>

                <!-- <div class="form-group">
                  <label>{{$t('kds.section')}}</label>
                  <select
                    name="type"
                    class="form-control"
                    v-model="model.kds_section_id"
                  >
                    <option :value="null" :label="$t('general.select')"> </option>
                    <option
                      v-for="section in kdsSections"
                      :value="section.id"
                      :label="section.name"
                      :key="section.id">
                    </option>
                  </select>
                </div> -->

                <!-- <div class="form-group">
                  <label>Limba</label>
                  <select
                    name="type" class="form-control"
                    v-model="model.language"
                  >
                    <option
                      v-for="lang in languages"
                      :value="lang.id"
                      :label="lang.label"
                      :key="lang.id">
                    </option>
                  </select>
                  <small class="text-danger" v-show="type.invalid">
                    {{ getError('type') }}
                  </small>
                </div> -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="padding: 5px;">

            <table class="table width-table" ref="sortableTable" style="margin: 0px; width: 100% !important;">
              <thead>
                <tr>
                  <th>{{$t('companyOptions.image')}}</th>
                  <th style="width: 70px;">Time in seconds between slides</th>
                  <th style="width: 70px;">From</th>
                  <th style="width: 70px;">To</th>
                  <th style="width: 70px;">Active</th>
                  <th> </th>
                </tr>
              </thead>
              <draggable v-model="model.images" :sort="false" :element="'tbody'">
                <template v-for="(item, index) in model.images">
                  <tr class="sortableRow" :key="'slide-' + index">
                    <tr>
                      <td >
                        <div class="form-group">
                          <label>{{$t('catalogProd.image')}}</label>
                            <el-upload
                              multiple
                              action=""
                              ref="upload"
                              :limit="50"
                              :file-list="item.images ? item.images : []"
                              list-type="picture-card"
                              accept=" .jpg, .jpeg, .png"
                              :on-change="(file,fileList) =>{return handleImgChnage(file,fileList,index)}"
                              :on-exceed="handleExceed"
                              :on-remove="(file,fileList) =>{return handleRemove(file,fileList,index)}"
                              :auto-upload="false">
                              <img src="/static/img/icons/icon-plus-primary.png">
                              <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                            </el-upload>
                          </div>
                      </td>
                      <td>
                        <tr>
                          <input type="text"
                                  placeholder=""
                                  class="form-control sml mar-bt-5"
                                  v-model="item.time"
                                  v-validate="modelValidate.required">
                        </tr>
                      </td>
                      <td>
                        <tr>
                          <el-time-select :disabled="false"
                                          placeholder="Select time"
                                          style="width: 100px;"
                                          :value="item.from"
                                          v-model="item.from"
                                          :picker-options="pickerOptions">
                          </el-time-select>
                                          <!-- v-validate="modelValidate.available_days" -->
                        </tr>
                      </td>
                      <td>
                        <tr>
                          <el-time-select :disabled="false"
                                          placeholder="Select time"
                                          style="width: 100px;"
                                          :value="item.to"
                                          v-model="item.to"
                                          :picker-options="pickerOptions">
                          </el-time-select>
                        </tr>
                      </td>
                      <td>
                        <tr style="height: 45px;">
                          <template>
                            <p-switch class="mar-bt-5 mar-to-5" v-model="item.active" type="success"></p-switch>
                          </template>
                        </tr>
                      </td>
                      <td>
                        <button class="btn btn-simple btn-icon" @click.prevent="deleteValue(index)"><i :title="$t('general.delete')" class="ti-close text-orange"></i></button>
                      </td>
                    </tr>
                  </tr>
                </template>
              </draggable>
            </table>
            <button class="btn add mar-to-15 mar-lt-20" @click.prevent="addNewImageGroup()">
              <img src="/static/img/icons/add.png">
              {{$t('general.add')}} {{$t('catalogProdOpt.value')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, TimeSelect} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import draggable from 'vuedraggable'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      draggable,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Button.name]: Button,
      [Input.name]: Input,
      PSwitch
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.company_id = this.$session.get('selectedCompany')
      // this.getKdsSections()
      this.getPoses()
      this.getData()
    },
    data () {
      return {
        company_id: 0,
        apiUrl: '',
        roles: [],
        kdsSections: [],
        allPoses: [],
        id: this.value || this.tableId,
        isNew: true,
        filelist: [],
        model: {
          'id': 0,
          'name': '',
          'location_id': '',
          'images': [],
          'location': {
            'id': null
          },
          'type': 2
        },
        type: ['ODS', 'POS', 'DSS'],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        },
        locations: [],
        modelValidate: {
          type: {required: true},
          server_ip: {required: true}
        },
        languages: [{'id': 'ro', 'label': 'Romana'}, {'id': 'en', 'label': 'English'}, {'id': 'es', 'label': 'Espagnol'}, {'id': 'gr', 'label': 'Greek'}, {'id': 'cz', 'label': 'Czech'}],
        loading: true
      }
    },
    methods: {
      getKdsSections () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        this.apiRequest('/kds-sections', 'GET', data, (response) => {
          if (response.status === true) {
            this.kdsSections = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      getPoses () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        this.apiRequest('/pos', 'GET', data, (response) => {
          if (response.status === true) {
            this.allPoses = response.data.pos

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        this.locations = []
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        let id = this.route.params.id
        if (id) {
          this.apiRequest('/pos/screens/' + id, 'GET', requestData, (response) => {
            if (response.status) {
              this.model = response.data.screens
              this.model.pos_image = [{'url': this.model.pos_image}]
              this.model.images = this.model.images.map(item => ({
                ...item,
                images: item.images.map(img => ({ url: img }))
              }))
            }
          })
        }

        this.apiRequest('/get-locations', 'GET', requestData, (response) => {
          if (response.status) {
            this.locations = response.data
          }
        })
        this.$nextTick(() => { this.loading = false })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      async saveTable () {
        this.$nextTick(() => { this.loading = true })
        if (this.model.location && this.model.location.id != null && this.model.location.id !== 'null') {
          this.model.location_id = this.model.location.id
        }
        try {
          await this.ensureSlideImagesBase64()
        } catch (e) {
          this.$nextTick(() => { this.loading = false })
          swal({
            toast: true,
            type: 'warning',
            text: this.$t('validations.wentWrong'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          return
        }
        let data = this.model
        var companyID = this.company_id
        data.token = this.$session.get('token')
        data.company_id = companyID

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/pos/screens/' + id
          request = 'PUT'
        } else {
          url = '/pos/screens/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.$nextTick(() => { this.loading = false })
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.$nextTick(() => { this.loading = false })
            this.handleErrors(response.errors)
          }
        })
      },
      deleteOrderScreen () {
        this.$nextTick(() => { this.loadingReset = true })
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.company_id,
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/pos/screens/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      deleteToken () {
        let data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'screen_id': this.model.id
        }
        swal({
          type: 'question',
          title: this.$t('settingTable.deleteZoneTitle'),
          text: this.$t('settingTable.disableAuthScreenInfo'),
          position: 'top-end',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no'),
          allowOutsideClick: false
        }).then((result) => {
          this.apiRequest('/pos/screens/delete-token', 'POST', data, (response) => {
            this.model.login_token = null
          })
        })
      },
      backButton () {
        // this.$session.set('selectedTab', this.$t('pages.posScreen'))
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/screens/tabs?tabIndex=1')
      },
      updateLocationId (event) {
        if (event.target.value !== 'null') {
          const selectedLocation = this.locations.find(item => parseInt(item.id) === parseInt(event.target.value))
          this.model.location_id = selectedLocation.id
        }
      },
      addNewImageGroup () {
        let newRow = {
          'images': [],
          'from': '00:00',
          'to': '24:00',
          'time': 10,
          'active': true
        }
        if (!this.model.images) {
          this.model.images = []
        }
        this.model.images.push(newRow)
      },
      deleteValue (index) {
        this.model.images.splice(index, 1)
        // Vue.set(this.model.images[index], 'delete', 1)
        // swal({'text': '', 'type': 'success', 'showConfirmButton': false, 'timer': 5000}).then(() => {}).catch(() => {})
      },
      handleRemove (file, fileList, index) {
        if (this.model.images[index]) {
          this.$set(this.model.images[index], 'images', fileList || [])
        }
      },
      ensureSlideImagesBase64 () {
        const groups = this.model.images || []
        const tasks = []
        groups.forEach((group) => {
          (group.images || []).forEach((img) => {
            if (img && img.raw && !img.base64enc) {
              tasks.push(this.getBase64(img.raw).then((base64enc) => {
                this.$set(img, 'base64enc', base64enc)
              }))
            }
          })
        })
        return Promise.all(tasks)
      },
      handleImgChnage (file, fileList, index) {
        const self = this
        let pp = this.model.images
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          self.$refs.upload.clearFiles()
          pp[index].images = []
        } else {
          pp[index].images = fileList
        }
        this.model.images = null
        this.model.images = pp
        this.ensureSlideImagesBase64().catch(() => {})
      },
      handleImgChnagePosImage (file, fileList) {
        let pp = this.model
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          pp.pos_image = []
        } else {
          if (fileList.length > 1) {
            pp.pos_image = fileList.slice(1)
          } else {
            pp.pos_image = fileList
          }
        }
        this.model = null
        this.model = pp
        this.getBase64(this.model.pos_image[0].raw).then((base64enc) => {
          this.model.pos_image[0].base64enc = base64enc
        })
      },
      handleRemovePosImage (file, fileList) {
        if (fileList.length === 0) {
          this.model.pos_image = []
        }
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      }
    }
  }
</script>
<style>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/PosScreen/PosScreenForm.vue